<div class="loading" *ngIf="!loaded"></div>
<div class="top-header-sm" [dir]="textDir">
    <label class="form-title">{{myGrade}} Grade name</label>
</div>
<div class="white" *ngIf="subjectList?.length" style="padding-bottom: 0px;" [dir]="textDir">
   
    <label class="marB20 label-light">{{ 'Assign subjects to this grade' | translate }}</label>
    <!-- <div class="grey-text" style="float: left;margin-left: 10px; margin-right: 10px;">
        Subjects
    </div> -->
    <div class="slist slistA" >
        <div *ngFor="let item of mySubjectList let i = index">
            <div class="checkbox marB5">
                <input #inputEl type="checkbox" id="{{'cb ' + (i+1)}}" [checked]="isChecked(item)" (change)="checkUncheckSubject(item, inputEl.checked)" [dir]="textDir">
                <label class="labeltxt" for="{{'cb ' + (i+1)}}">{{item.name | ucfirst}}</label>
<!--                 <label><input type="checkbox" [checked]="isChecked(item)" (change)="checkUncheckSubject(item)">{{item.name | ucfirst}}</label>
 -->            </div>

        </div>
    </div>
    <div class="row">
    <div class="info-section marT20 marB20 flexStart" ><i class="icon icon-info info-txt padR5 padT3"></i><label class="info-txt" [dir]="textDir">{{'To add a subject not listed here' | translate }}</label></div>
    </div>
</div>

